import { createContext } from 'react';
import { createBatcher } from '../components/AnimateSharedLayout/utils/batcher.js';

var SharedLayoutContext = createContext(createBatcher());
/**
 * @internal
 */
var FramerTreeLayoutContext = createContext(createBatcher());
function isSharedLayout(context) {
    return !!context.forceUpdate;
}

export { FramerTreeLayoutContext, SharedLayoutContext, isSharedLayout };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/context/SharedLayoutContext.js
// module id = 22
// module chunks = 0